import { FilePdfOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import Box from '~/core/Box'
import Button from '~/core/Button'
import {
    OnViewInspectionButtonClickFuncArgsType,
    OrderedItemsRecordType,
} from '../types'
import {
    TOOLING_CHANGE_PROCESSES_ID,
    TOOLING_PROCESSES_IDS,
} from '~/lib/partsConstants'

import { useGetShipment } from './logic'

export const PLACEMENT = 'QUALITY_DOCS_AND_PHOTOS_CELL'
export const VIEW_PHOTOS_BTN_NAME = 'view-photos'
const TOOLTIP_DISABLE_MSG =
    'Quality documents and photos will be available once parts have shipped.'

const BUTTON_STYLE = {
    maxWidth: '154px',
    padding: '4px 12px 4px 10px',
}

type QualityDocsAndPhotoCellPropsType = {
    record: OrderedItemsRecordType
    onViewInspectionButtonClick: (
        args: OnViewInspectionButtonClickFuncArgsType,
    ) => void
}

const QualityDocsAndPhotosCell = (props: QualityDocsAndPhotoCellPropsType) => {
    const { onViewInspectionButtonClick, record: partData } = props

    const shipment = useGetShipment({ shipments: partData.shipments })

    const isTooling = partData?.processes?.some(
        ({ platformProcessId }) =>
            platformProcessId &&
            (TOOLING_CHANGE_PROCESSES_ID?.indexOf(platformProcessId) >= 0 ||
                TOOLING_PROCESSES_IDS?.indexOf(platformProcessId) >= 0),
    )

    const isViewDocBtnVisible =
        !isTooling && shipment?.inspectionDocuments?.length

    return (
        <Tooltip title={!shipment ? TOOLTIP_DISABLE_MSG : null}>
            <Box direction="col" alignItems="center">
                {isViewDocBtnVisible ? (
                    <Button
                        data-test-target={`${VIEW_PHOTOS_BTN_NAME}-${PLACEMENT}`}
                        name={VIEW_PHOTOS_BTN_NAME}
                        onClick={(evt: Event) =>
                            onViewInspectionButtonClick({
                                evt,
                                partData,
                                shipment: shipment || null,
                            })
                        }
                        placement={PLACEMENT}
                        style={{
                            pointerEvents: shipment ? 'auto' : 'none',
                            ...BUTTON_STYLE,
                        }}
                    >
                        <FilePdfOutlined />
                        View quality docs
                    </Button>
                ) : (
                    <>-</>
                )}
            </Box>
        </Tooltip>
    )
}

export default QualityDocsAndPhotosCell
